// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Om9d","header":"MessagesList_header__3CRRa","chat":"MessagesList_chat__3JAmy"};